import { GET_AFFILIATE, BLOCK_UNBLOCK_AFFILIATE, DELETE_AFFILIATE, GET_SINGLE_AFFILIATE } from "./affiliate.type";

const initialState = {
  affiliate: {
    data: [],
    total: 0
  },
  singleAffiliate: null,
};

export const affiliateReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AFFILIATE:
      return {
        ...state,
        affiliate: action.payload,
      };

    case BLOCK_UNBLOCK_AFFILIATE:
      return {
        ...state,
        affiliate: {
          ...state.affiliate,
          data: state.affiliate.data.map((affiliate) =>
            affiliate._id === action.payload._id ? action.payload : affiliate
          ),
        },
      };

    case DELETE_AFFILIATE:
      return {
        ...state,
        affiliate: {
          ...state.affiliate,
          data: state.affiliate.data.filter(
            (affiliate) => affiliate._id !== action.payload
          ),
        },
      };

    case GET_SINGLE_AFFILIATE:
      return {
        ...state,
        singleAffiliate: action.payload,
      };

    default:
      return state;
  }
};